<template>
    <div>
        <info-modal
            ref="infoModal"
            @ok-submit="closeModal"
            :msg="infoMsg"
        >
        </info-modal>
        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeModal"
            :msg="errorMsg"
        />
        <div class="bg-leave-liff">
            <div class="header-text">
                <div>
                    {{ $vuetify.lang.t('$vuetify.liff.leaveOnsite') }}
                </div>
                <span class="lang mr-3">
                    <change-lang />
                </span>
            </div>
            <v-form
                ref="form"
                v-model="valid"
                class="form-container"
                lazy-validation>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.leaveType') }}
                    </span>
                    <v-select
                        v-model="form.laoType"
                        :items="laoTypes"
                        :rules="inputRules"
                        :error-messages="errors.lao_type"
                        solo
                        height="40px"
                        :placeholder="$vuetify.lang.t('$vuetify.liff.selectType')"
                        item-text="text"
                        item-value="value">
                    </v-select>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.choice') }}
                    </span>
                    <v-radio-group v-model="isSingleDay" row>
                        <v-radio :label="$vuetify.lang.t('$vuetify.liff.singleDay')" :value=true></v-radio>
                        <v-radio :label="$vuetify.lang.t('$vuetify.liff.range')" :value=false></v-radio>
                    </v-radio-group>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.startDate') }}
                    </span>
                    <v-menu
                        v-model="datePickerStartDateShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="dateFormattedStartDate"
                            prepend-inner-icon="event"
                            @click:prepend="datePickerStartDateShow = true"
                            :rules="inputRules"
                            :error-messages="errors.date"
                            solo
                            height="40px"
                            readonly
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker :locale="localeLang" v-model="form.startDate" @input="datePickerStartDateShow = false"></v-date-picker>
                    </v-menu>
                </div>
                <div v-if="!isSingleDay">
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.endDate') }}
                    </span>
                    <v-menu
                        v-model="datePickerEndDateShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="dateFormattedEndDate"
                            prepend-inner-icon="event"
                            @click:prepend="datePickerEndDateShow = true"
                            :rules="inputRules"
                            :error-messages="errors.date"
                            solo
                            height="40px"
                            readonly
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker :locale="localeLang" v-model="form.endDate" @input="datePickerEndDateShow = false"></v-date-picker>
                    </v-menu>
                </div>
                <div v-if="isSingleDay">
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.time') }}
                    </span>
                    <v-select
                        :placeholder="$vuetify.lang.t('$vuetify.liff.selectPeriodType')"
                        prepend-inner-icon="mdi-clock"
                        v-model="form.periodType"
                        :items="laoPeriodTypes"
                        :rules="inputRules"
                        solo
                        height="40px"
                        item-text="text"
                        item-value="value">
                    </v-select>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.attachFile') }}
                    </span>
                    <v-text-field
                        v-model="fileName"
                        :placeholder="$vuetify.lang.t('$vuetify.liff.fileImage')"
                        prepend-inner-icon="mdi-folder-upload"
                        @click="changeFile()"
                        @click:prepend-inner="changeFile()"
                        clearable
                        @click:clear="onClearClicked()"
                        solo
                        height="40px"
                        readonly>
                    </v-text-field>
                    <input
                        ref="file"
                        type="file"
                        class="file-lao"
                        accept="image/*"
                        @change="onSelectFile">
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.liff.reason') }}
                    </span>
                    <v-textarea
                        label="Reason"
                        :placeholder="$vuetify.lang.t('$vuetify.liff.reasonMsg')"
                        v-model="form.description"
                        counter
                        no-resize
                        solo
                        height="90px"
                        :rules="descriptionRules"
                        :maxlength="255">
                    </v-textarea>
                </div>

                <div class="flex-center">
                    <v-btn
                    class="margin-rigth"
                    @click="closeWindow">
                        {{ $vuetify.lang.t('$vuetify.liff.cancel') }}
                    </v-btn>
                    <v-btn
                    color="primary"
                    :disabled="!lineUserId"
                    @click="submitForm">
                        {{ $vuetify.lang.t('$vuetify.liff.submit') }}
                    </v-btn>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import InfoModal from '@/components/modal/InfoModal'
import ChangeLang from '@/components/liff/ChangeLang'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
export default {
    name: 'LeaveApplication',

    components: {
        InfoModal,
        ChangeLang,
        LiffErrorModal
    },

    data () {
        return {
            valid: true,
            form: {
                startDate: this.$util.getCurrentDate(),
                endDate: this.$util.getCurrentDate(),
                description: '',
                periodType: '',
                image: null
            },
            inputRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.liff.fieldRequired')
            ],
            descriptionRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.liff.fieldRequired'),
                v => v.length < 255 || this.$vuetify.lang.t('$vuetify.liff.fieldLessThanCharacters')
            ],
            fileName: '',
            lineUserId: null,
            laoTypes: [],
            laoPeriodTypes: [],
            datePickerStartDateShow: false,
            datePickerEndDateShow: false,
            dateFormattedStartDate: this.$util.formatDate(this.$util.getCurrentDate()),
            dateFormattedEndDate: this.$util.formatDate(this.$util.getCurrentDate()),
            isSingleDay: true,
            infoMsg: null,
            errorMsg: '',
            errors: []
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        }
    },

    methods: {
        async getLaoType () {
            const res = await axios.get(`${process.env.VUE_APP_BACKEND}/leave-or-onsite/type`, {
                headers: {
                    'Accept-Language': this.$vuetify.lang.current
                }
            })
            if (res && res.data && res.data.status === 'ok') {
                this.laoTypes = res.data.data
            }
        },

        async getLaoPeriodType () {
            const res = await axios.get(`${process.env.VUE_APP_BACKEND}/leave-or-onsite/period-type`, {
                headers: {
                    'Accept-Language': this.$vuetify.lang.current
                }
            })
            if (res && res.data && res.data.status === 'ok') {
                this.laoPeriodTypes = res.data.data
            }
        },

        errorAlert (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        closeModal () {
            this.closeWindow()
        },

        async submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)

            const { startDate, endDate, laoType, image, description, periodType } = this.form
            const submitForm = {
                user_id: this.lineUserId,
                start_date: startDate,
                end_date: this.isSingleDay ? startDate : endDate,
                lao_type: laoType,
                image: image,
                description: description
            }

            // send period_type only single day
            if (this.isSingleDay) {
                submitForm.period_type = periodType
            // for not single day, period_type period type will be full day
            } else {
                submitForm.period_type = 'FLD'
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/leave-or-onsite/create`, submitForm)
            if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'ok') {
                if (this.isSingleDay) {
                    this.infoMsg = this.$vuetify.lang.t('$vuetify.liff.msgSuccessSingleDay').replace('$startDate', this.$util.formatDate(startDate))
                } else {
                    this.infoMsg = this.$vuetify.lang.t('$vuetify.liff.msgSuccessRange').replace('$startDate', this.$util.formatDate(startDate)).replace('$endDate', this.$util.formatDate(endDate))
                }

                this.$store.dispatch('setLoading', false)
                this.$refs.infoModal.dialog = true
            } else {
                this.$store.dispatch('setLoading', false)
                this.errorAlert(res.data.msg)
            }
        },

        changeFile () {
            this.$refs.file.click()
        },

        onSelectFile (files) {
            const fileList = event.target.files

            const reader = new FileReader()
            if (fileList[0]) {
                reader.onload = () => {
                    //  reader.result is base64
                    this.form.image = reader.result
                }

                reader.readAsDataURL(fileList[0])
                this.fileName = fileList[0].name
            }
        },

        onClearClicked () {
            this.fileName = ''
            this.form.image = ''
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.lineUserId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_LIFF)
            await this.getLaoType()
            await this.getLaoPeriodType()
        } catch (error) {
            this.errorAlert(this.$vuetify.lang.t('$vuetify.liff.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        'form.startDate' () {
            this.dateFormattedStartDate = this.$util.formatDate(this.form.startDate)
        },
        'form.endDate' () {
            this.dateFormattedEndDate = this.$util.formatDate(this.form.endDate)
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getLaoType()
                await this.getLaoPeriodType()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

.flex-center {
    display: flex;
    justify-content: center;
    height: 40px;
}

.margin-rigth {
    margin-right: 16px;
}

.file-lao {
    display: none;
}

.bg-leave-liff {
    background-color: #2E2929;
    color: #ffffff;
    height: 100vh;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form-container {
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
        padding: 2rem;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 90%;
    }

    .label-tag {
        font-size: 12px;
        color: #757575;
    }
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

.text-underline {
    text-decoration: underline;
    color: #d76436;
}
</style>
